module.exports = __webpack_public_path__ + "img/big5-6.fe665937.jpg";